import { Box, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

export default function PageTitle({
  title,
  subTitle,
}: {
  title: string;
  subTitle?: string | ReactNode;
}) {
  const theme = useTheme();
  return (
    <Box sx={{ pt: 2, pb: 3 }}>
      <Typography
        variant="h5"
        component="h1"
        sx={{
          fontWeight: 700,
          color: theme.palette.text.primary,
          textShadow: `2px 2px 0px ${theme.palette.secondary.main}`,
          pb: subTitle ? 0.5 : 0,
          maxWidth: { xs: "100%", sm: "50%" },
        }}
      >
        {title}
      </Typography>
      {subTitle ? (
        <Typography
          variant="body1"
          sx={{
            pt: 1,
            color: theme.palette.text.secondary,
          }}
        >
          {subTitle}
        </Typography>
      ) : null}
    </Box>
  );
}
